import {useNavigate} from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import {Autoplay, Pagination} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import SpinnerLoading from '../../../../../components/SpinnerLoading';
import useGetSummaryStateList from '../../../../../services/hookService/getSummaryStateList/useGetSummaryStateList';
import './styles.css';

const StoreContracts = () => {
  const navigate = useNavigate();
  const {data, isLoading} = useGetSummaryStateList();

  // Split cities into chunks of 10
  const chunkSize = 10;
  const cityChunks = [];
  if (data) {
    for (let i = 0; i < data?.length; i += chunkSize) {
      cityChunks.push(data?.slice(i, i + chunkSize));
    }
  }

  return (
    <div className="mt-4">
      <p className="font-semibold text-orange-400 text-md">
        فروشگاه‌های طرف قرارداد
      </p>

      <div className="bg-gray-100 rounded-xl p-3 mt-3 flex gap-3 min-h-[200px]">
        {isLoading && (
          <div className="flex items-center justify-center mx-auto">
            <SpinnerLoading />
          </div>
        )}

        {!isLoading && data && data.length > 0 && (
          <Swiper
            spaceBetween={50}
            slidesPerView={1}
            modules={[Pagination, Autoplay]}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{
              clickable: true,
              dynamicBullets: false,
              type: 'bullets',
            }}
            loop={cityChunks.length > 1}
            className="!relative"
          >
            {cityChunks.map((chunk, index) => (
              <SwiperSlide key={index}>
                <div className="grid grid-cols-5 grid-rows-2 gap-2">
                  {chunk.map(city => (
                    <div
                      key={city.id}
                      onClick={() =>
                        navigate(`/city-contract-stores/${city.id}`)
                      }
                      className="flex items-center justify-center p-2 text-xs text-center bg-white rounded-full shadow-sm cursor-pointer w-14 h-14 text-farm-shop-500 font-Medium"
                    >
                      {city?.name}
                    </div>
                  ))}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};

export default StoreContracts;
